import React from 'react';
import { Box } from '@mui/material';
import { CustomCellProps } from 'components/common/grid/';
import { getCellContent, getCellWithTooltip } from 'components/common/grid/cell';
import { applyGridFilters } from 'components/common/grid/gridEvents';
import useBundleTranslation from 'i18n';

interface LastGenerationCellProps extends CustomCellProps {
    reportAiInsightId?: number;
    // The Generation History grid on the same page; the click filters it to this insight (AI_Insights.md §7.3).
    targetGridUid?: string;
}

export default function LastGenerationCell({
    text,
    color,
    subText,
    tooltip,
    rawTooltipHtml,
    reportAiInsightId,
    targetGridUid,
    t,
}: LastGenerationCellProps) {
    const { t: tMain } = useBundleTranslation('main');
    const tFn = t ?? tMain;

    const onClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!targetGridUid || !reportAiInsightId) return;
        applyGridFilters(targetGridUid, { report_ai_insight_id: String(reportAiInsightId) });
    };

    const cell = (
        <Box
            component="span"
            role="button"
            onClick={onClick}
            sx={{ cursor: 'pointer', display: 'inline-block' }}
            data-test={`ai_insight_last_generation_${reportAiInsightId ?? ''}`}
        >
            {getCellContent(text ? String(text) : '', undefined, false, undefined, subText, color)}
        </Box>
    );

    return tooltip ? getCellWithTooltip(cell, tooltip, rawTooltipHtml, tFn) : cell;
}
